import { render } from "./KRSubHeader.vue?vue&type=template&id=24c5694e&scoped=true"
import script from "./KRSubHeader.vue?vue&type=script&lang=js"
export * from "./KRSubHeader.vue?vue&type=script&lang=js"

import "./KRSubHeader.vue?vue&type=style&index=0&id=24c5694e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24c5694e"

export default script